
export default function Hero() {
  const scrollToCategories = () => {
    const categoriesSection = document.getElementById('categories-section');
    if (categoriesSection) {
      categoriesSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToFeaturedArtworks = () => {
    const featuredSection = document.getElementById('featured-artworks-section');
    if (featuredSection) {
      featuredSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.6)), url('https://public.readdy.ai/ai/img_res/8fe226533099813905a4fa673834e2d7.jpg')`
      }}
    >
      <div className="container mx-auto px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
            Sanatın
            <span className="block text-white bg-gradient-to-r from-white to-gray-200 bg-clip-text text-transparent" style={{ WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
              Büyüleyici Dünyası
            </span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 mb-8 leading-relaxed">
            Yağlı boya ve sulu boya tablolardan oluşan benzersiz koleksiyonumuzu keşfedin. 
            Her eser, sanatçının ruhunu yansıtan özgün bir hikaye anlatır.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={scrollToFeaturedArtworks}
              className="bg-white text-black px-8 py-4 text-lg font-semibold hover:bg-gray-200 transition-colors cursor-pointer whitespace-nowrap"
            >
              Koleksiyonu Keşfet
            </button>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div 
          onClick={scrollToCategories}
          className="w-6 h-6 flex items-center justify-center cursor-pointer"
        >
          <i className="ri-arrow-down-line text-2xl text-white"></i>
        </div>
      </div>
    </section>
  );
}
